import { Entity, Field } from '@adornis/baseql/decorators';
import { EntityData } from '@adornis/baseql/entities/adornisEntity';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity';
import { Message, Recipient } from '@adornis/mails/server/communication';
import { validate } from '@adornis/validation/decorators';
import { nonOptional } from '@adornis/validation/functions/nonOptional';
import { Document } from 'bson';
import { config } from 'config';
import { DateTime } from 'luxon';
import { InsertOneResult } from 'mongodb';
import { mailer } from './../server/mailer';
import { WTGUser } from './wtg-user';

@Entity()
export class WelcomeBox extends MongoEntity {
  public static _class = 'WelcomeBox';
  public static _collectionName = 'welcome-boxes';

  @Field(type => Boolean, { default: v => v ?? false }) public alreadyInGermany!: boolean;
  @Field(type => DateTime)
  @validate((val, name, entity: WelcomeBox) => {
    if (!entity.alreadyInGermany) nonOptional()(val, name, entity);
  })
  public preOrderArrival!: DateTime;
  @Field(type => String) @validate(nonOptional()) public pickUpCity!: string;
  @Field(type => String) @validate(nonOptional()) public partnerLocation!: string;
  @Field(type => String) @validate(nonOptional()) public userID!: string;

  constructor(doc: EntityData<WelcomeBox>) {
    super(doc);
  }

  public static async afterCreate(entity: WelcomeBox, result: InsertOneResult<Document>) {
    const user = await WTGUser.getByID<WTGUser>(entity.userID)(WTGUser.allFields);
    if (!user) throw new Error('user has disappeared');
    await mailer.sendMail(
      new Message({
        subject: 'New Welcome Box Signup',
        html: `Welcome Box Signup: <br/><br/>
User: ${user.email} <br/><br/>
Is ${entity.alreadyInGermany ? 'already' : 'not yet'} in Germany. <br/>
${
  entity.alreadyInGermany
    ? ''
    : `
Preorders for ${entity.preOrderArrival.toLocaleString(DateTime.DATE_FULL)}. <br/>
`
}
City: ${entity.pickUpCity}. <br/>
Event or Location: ${entity.partnerLocation}. 
`,
      }),
      new Recipient(config.get('ADMIN_MAIL')),
    );
  }
}
